import React from 'react';
import './About.css';

const Contact = () => {
    return (
        <div className="contact-page">
            <section className="contact-hero" data-aos="fade-up">
                <h1>Contact <span>Us</span></h1>
                <p>Have questions? Reach out to our experts today.</p>
            </section>

            <section className="contact-form-section">
                <div className="contact-grid">
                    <div className="contact-info glass" data-aos="fade-right">
                        <h3>Reach Out</h3>
                        <p><strong>Email:</strong> <a href="mailto:theictheic90@gmail.com">theictheic90@gmail.com</a></p>
                        <p><strong>Phone:</strong> <a href="tel:+919398580968">+91 9398580968</a></p>
                        <p><strong>Location:</strong>  Bangalore/Hyderabad, India.</p>
                    </div>
                    <form className="contact-form glass" data-aos="fade-left">
                        <input type="text" placeholder="Name" required />
                        <input type="email" placeholder="Email" required />
                        <textarea placeholder="Your Message" rows="5" required></textarea>
                        <button type="submit" className="btn btn-gold">Send Message</button>
                    </form>
                </div>
            </section>
        </div>
    );
};

export default Contact;